import React, { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box, Button } from "@mui/material";
import DialogContentModal from "../components/DialogContent";
import MapSubmissionSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/map-submission/Summary/MapSubmissionSummary";
import MapSubmissionSummarys from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/resedential-self/MapSubmissionSummary";

const Architect = ({ formData, applicationDocs, totalAmount, edcrDetails, collectionBillDetails, actions }) => {
  let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  const isTcp = formData?.applicationNo?.includes("TCP");
  const { t } = useTranslation();
  const tenantId = Digit.ULBService.getStateId();
  const status = formData?.status === "APPROVED" || formData?.status === "APPROVED_JE";
  const isPlinth = formData?.planOn === "plinth_submission";
  const isCompounding = formData?.applicationType === "FORM_COMPOUNDING";
  function getApprovalLetter(item) {
    if (isPlinth) {
      const pdfUrl = item?.plinthApprovalCertificateUrl;
      window.open(pdfUrl, "_blank");
      return;
    }
    if (isCompounding) {
      const pdfUrl = item?.compoundingApprovalLetterUrl;
      window.open(pdfUrl, "_blank");
      return;
    }
    const pdfUrl = item?.approvalCertificateUrl;
    window.open(pdfUrl, "_blank");
  }
  function getApprovalPDFLetter(item) {
    const pdfUrl = item?.selfDrawingPdfUrl;
    window.open(pdfUrl, "_blank");
  }
  const { data: { BPA: { logoStore } = {} } = {}, isLoading: isLogoLoading } = Digit.Hooks.obps.useMDMS(tenantId, "BPA", ["logoStore"]);
  const avpLogo = logoStore?.find((item) => item.code === "up.avp");
  const daLogo = logoStore?.find((item) => item.code === "up.da");
  return (
    <React.Fragment>
      {/* {user?.info?.type ==="CITIZEN" &&( */}
      <div style={{ backgroundColor: "rgba(173, 229, 232, 0.69)", padding: "10px" }}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)">
          <Box gridColumn="span 3" sx={{ ml: 2 }}>
            <b>{t(`BPA_APPLICATION_NUMBER_LABEL`)}</b>
          </Box>
          <Box gridColumn="span 3" sx={{ ml: 2 }}>
            : &nbsp;&nbsp; {formData?.applicationNo || ""}
          </Box>
          <Box gridColumn="span 6" sx={{ ml: 2 }}>
            <button
              className="btn btn-primary"
              style={{ padding: "1px" }}
              onClick={() => {
                setSmShow(true), console.log("modal open");
              }}
            >
              View Application
            </button>
          </Box>
          <Box gridColumn="span 3" sx={{ ml: 2 }}>
            <b>Mobile Number</b>
          </Box>
          <Box gridColumn="span 9" sx={{ ml: 2 }}>
            {formData?.landInfo?.owners && formData?.landInfo?.owners?.map((ob, index) => <div>: &nbsp;&nbsp; {ob?.mobileNumber}</div>)}
          </Box>
          <Box gridColumn="span 3" sx={{ ml: 2 }}>
            <b>Owner name</b>
          </Box>
          <Box gridColumn="span 9" sx={{ ml: 2 }}>
            {formData?.landInfo?.owners && formData?.landInfo?.owners?.map((ob, index) => <div>: &nbsp;&nbsp; {ob?.name}</div>)}
          </Box>
          <Box gridColumn="span 3" sx={{ ml: 2 }}>
            <b>Applied For </b>
          </Box>
          <Box gridColumn="span 9" sx={{ ml: 2 }}>
            : &nbsp;&nbsp;{" "}
            {formData?.planOn === "SELF_MAP"
              ? "Self Certification via Registration"
              : formData?.planOn === "Self Certification of residential Plot Area upto 300 SqM on approved layouts" ||
                formData?.planOn === "Self Approval via LTP of Residential Plot up to 500 sqm and Commercial plot up to 200 sqm"
              ? "Self Approval via LTP"
              : formData?.planOn === "plinth_submission"
              ? "Plinth Submission"
              : "Map Submission"}
          </Box>
          {status && (
            <Box gridColumn="span 3" sx={{ ml: 2 }}>
              <b>Approval Letter </b>
            </Box>
          )}
          {status && (
            <Box gridColumn="span 9" sx={{ ml: 2 }}>
              :{" "}
              <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => getApprovalLetter(formData)}>
                <span>View</span>
              </Button>
            </Box>
          )}
          {status && !isPlinth && (
            <Box gridColumn="span 3" sx={{ ml: 2 }}>
              <b>Drawing PDF </b>
            </Box>
          )}
          {status && !isPlinth && (
            <Box gridColumn="span 9" sx={{ ml: 2 }}>
              :{" "}
              <Button size="small" className="btn-table-action" variant="contained" color="primary" onClick={() => getApprovalPDFLetter(formData)}>
                <span>View</span>
              </Button>
            </Box>
          )}
        </Box>
        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShow}
          onClose={() => {
            setSmShow(false);
          }}
        >
          {formData?.plotinMelaArea === "no" ? (
            <MapSubmissionSummarys formData={formData} logoData={formData?.department === "DA" ? daLogo : avpLogo} />
          ) : (
            <MapSubmissionSummary
              formData={formData}
              applicationDocs={applicationDocs}
              totalAmount={totalAmount}
              edcrDetails={edcrDetails}
              collectionBillDetails={collectionBillDetails}
            />
          )}
        </DialogContentModal>
      </div>
      {/* )} */}
    </React.Fragment>
  );
};
export default Architect;
